module.exports = __webpack_public_path__ + "media/images/landings/promotion_5/img-campaign-sp-52a56aa158ad93dc32eec4c32d12ef09.png";